// extracted by mini-css-extract-plugin
export default {"workspace":"App_workspace__uHMzQ","button-add":"App_button-add__FR-46"};